import { Component, inject } from '@angular/core';
import { CeDialogComponent, CeDialogImports } from '@kempower-nx-workspace/shared/kp-design-system';
import { CookieService } from '@kempower-nx-workspace/chargeye-shared';
@Component({
    selector: 'ce-core-cookie-banner',
    imports: [CeDialogImports],
    templateUrl: './cookie-banner.component.html',
    styleUrl: './cookie-banner.component.scss'
})
export class CeCookieBannerComponent {
    // current website domain
    domain: string = window.location.hostname;
    readonly #dialog = inject(CeDialogComponent);
    readonly #cookieService = inject(CookieService);

    orgInfo!: any;

    constructor() {
        const cacheOrgInfo = localStorage.getItem('chargeye-organization-info');
        if (cacheOrgInfo !== null) {
            this.orgInfo = JSON.parse(cacheOrgInfo);
        }
    }

    closeBanner(): void {
        this.#dialog.closeDialog(this.#dialog);
    }

    giveConsent(consentGranted: boolean): void {
        const consentSelected = consentGranted ? 'granted' : 'denied';
        this.#cookieService.setApplicationBaseChoice(consentSelected === 'granted');
        this.closeBanner();
        window.location.reload();
    }
}
